<div style="margin: 10px">
  <div class="grid align-items-end" style="margin-bottom: 20px !important">
    <div class="col-1" *ngIf="mostrarBtnAgregar">
      <button type="button" pButton
              icon="fa fa-plus"
              label="{{ 'BTN_AGREGAR' | translate }}"
              class="btn-primary-full w-full"
              (click)="crear()">
      </button>
    </div>
    <div [ngClass]="{'col-3': mostrarBtnAgregar, 'col-4': !mostrarBtnAgregar}">
      <div class="div-form mb-0">
        <input type="text" pInputText
               placeholder="{{ 'LBL_BUSCAR' | translate }}"
               [value]="busqueda"
               (input)="buscar( $event.target.value )">
      </div>
    </div>
    <div class="col-12 md:col-2 lg:col-2">
      <div class="div-form mb-0">
        <label>{{ 'ADMGAR.LBL_TIPO_GARANTIA' | translate }}</label>
        <p-dropdown [options]="lisTiposGarantia"
                    [(ngModel)]="filtroTipoGarantia"
                    optionLabel="label"
                    optionValue="value"
                    emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}">
        </p-dropdown>
      </div>
    </div>

    <div class="col-12 md:col-2 lg:col-2">
      <div class="div-form mb-0">
        <label>{{ 'ADMGAR.LBL_CLASE_GARANTIA' | translate }}</label>
        <p-dropdown [options]="lisClasesGarantia"
                    [(ngModel)]="filtroClaseGarantia"
                    optionLabel="label"
                    optionValue="value"
                    emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}">
        </p-dropdown>
      </div>
    </div>

    <div class="col-12 md:col-2 lg:col-2">
      <div class="div-form mb-0">
        <label>{{ 'LBL_ESTADO' | translate }}</label>
        <p-dropdown [options]="lisEstados"
                    [(ngModel)]="filtroEstado"
                    optionLabel="label"
                    optionValue="value">
        </p-dropdown>
      </div>
    </div>

    <div class="col-1">
      <button type="button" pButton
              icon="fa fa-filter"
              label="{{ 'BTN_FILTRAR' | translate }}"
              class="btn-primary-outline w-full"
              (click)="aplicarFiltros()">
      </button>
    </div>
    <div class="col-1">
      <button type="button" pButton
              icon="fa fa-eraser"
              label="{{ 'BTN_LIMPIAR' | translate }}"
              class="btn-primary-outline w-full"
              (click)="limpiarFiltros()">
      </button>
    </div>
  </div>

  <p-table #dt
           [columns]="columnas"
           [value]="garantiasFiltradas"
           [loading]="cargando"
           selectionMode="single"
           dataKey="idGarantia"
           [paginator]="true"
           [rows]="10"
           paginatorPosition="bottom"
           styleClass="table-premium"
           responsiveLayout="scroll"
           [tableStyle]="{'min-width': '1600px'}">

    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns"
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sort"
            class="text-center">
          {{ col.header | translate }}
          <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr [pSelectableRow]="row">
        <td>{{ row.tipoGarantia }}</td>
        <td>{{ row.otraGarantia }}</td>
        <td>{{ row.bienDeDerecho }}</td>
        <td class="text-center">{{ row.codigoShivam }}</td>
        <td class="text-center">{{ row.codigoSuperf }}</td>
        <ng-container *ngFor="let m of lisModalidades">
          <td class="text-center">
            {{ (row[getCampoModalidad(m.codigo)] ? ('LBL_SI' | translate) : ('LBL_NO' | translate)) | uppercase }}
          </td>
        </ng-container>
        <td class="text-center">
          {{ (row.indicadorRequiereConstitucion ? ('LBL_SI' | translate) : ('LBL_NO' | translate)) | uppercase }}
        </td>
        <td class="text-center">
          {{ (row.indicadorRequiereReserva ? ('LBL_SI' | translate) : ('LBL_NO' | translate)) | uppercase }}
        </td>
        <td class="text-center">
          {{ row.fechaActivacion ? (row.fechaActivacion | date: 'dd/MM/yyyy HH:mm') : '--' }}
        </td>
        <td>{{ row.pagarePersonaNatural || '--' }}</td>
        <td>{{ row.pagarePersonaJuridica || '--' }}</td>
        <td>{{ row.seguro || '--' }}</td>
        <td class="text-center">
            <span *ngIf="row.indicadorHabilitado" class="badge-habilitado">
              {{ 'ADMGAR.LBL_HABILITADO' | translate | uppercase }}
            </span>
          <span *ngIf="!row.indicadorHabilitado" class="badge-inhabilitado">
              {{ 'ADMGAR.LBL_INHABILITADO' | translate | uppercase }}
            </span>
        </td>
        <td class="text-center" *ngIf="mostrarBtnAcciones">
          <button type="button" pButton
                  class="btn-action-premium"
                  icon="fa fa-pencil"
                  title="{{ 'BTN_EDITAR' | translate }}"
                  (click)="editar( row )">
          </button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns?.length || 1" class="text-center">
          {{ 'MSG_NOHAYREGISTROS' | translate }}
        </td>
      </tr>
    </ng-template>

  </p-table>
</div>

<p-confirmDialog #cd key="delete">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close"
            label="{{ 'BTN_CANCELAR' | translate }}"
            class="btn-primary-outline"
            (click)="cd.reject()">
    </button>
    <button type="button" pButton icon="fa fa-trash"
            label="{{ 'BTN_ELIMINAR' | translate }}"
            class="btn-tipo-cancelar"
            (click)="cd.accept()">
    </button>
  </ng-template>
</p-confirmDialog>

<p-confirmDialog #cdUnsaved
                 key="unsaved"
                 [style]="{width: '420px'}"
                 acceptLabel="Sí"
                 rejectLabel="No"
                 acceptIcon="fa fa-check"
                 rejectIcon="fa fa-times"
                 acceptButtonStyleClass="btn-primary-full"
                 rejectButtonStyleClass="btn-primary-outline">
</p-confirmDialog>

<p-dialog *ngIf="mostrarModal"
          [(visible)]="mostrarModal"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          [style]="{width: '860px', 'max-width': '96vw'}"
          styleClass="admgar-modal-garantia">

  <ng-template pTemplate="header">
    <div class="admgar-modal-header">
      <span class="admgar-modal-titulo">{{ 'ADMGAR.MODAL_TITULO' | translate }}</span>
      <button type="button" class="admgar-modal-cerrar" (click)="cerrarModal()" title="Cerrar">
        <i class="fa fa-times"></i>
      </button>
    </div>
  </ng-template>

  <p-tabView [(activeIndex)]="tabEditarActiva"
             styleClass="admgar-tabs"
             (onChange)="onCambiarTab($event)">

    <p-tabPanel *ngIf="mostrarTabConfiguracion"
                [header]="'ADMGAR.TAB_CONFIGURACION' | translate">
      <ng-container *ngTemplateOutlet="camposFormTpl"></ng-container>
    </p-tabPanel>

    <p-tabPanel *ngIf="modoEdicion && mostrarTabHistorial"
                [header]="'ADMGAR.TAB_HISTORIAL' | translate">

      <p-table [value]="historialCambios"
               [loading]="cargandoHistorial"
               [paginator]="true"
               [rows]="10"
               paginatorPosition="bottom"
               styleClass="table-premium"
               responsiveLayout="scroll">

        <ng-template pTemplate="header">
          <tr>
            <th style="width:24%;">{{ 'ADMGAR.COL_CAMPO' | translate }}</th>
            <th class="text-center" style="width:18%;">{{ 'ADMGAR.COL_VALOR_ANTERIOR' | translate }}</th>
            <th class="text-center" style="width:18%;">{{ 'ADMGAR.COL_VALOR_NUEVO' | translate }}</th>
            <th class="text-center" style="width:20%;">{{ 'ADMGAR.COL_USUARIO' | translate }}</th>
            <th class="text-center" style="width:20%;">{{ 'ADMGAR.COL_FECHA' | translate }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.campo }}</td>
            <td class="text-center">{{ resolverValorHistorial(row, 'valorAnterior') }}</td>
            <td class="text-center">{{ resolverValorHistorial(row, 'valorNuevo') }}</td>
            <td class="text-center">{{ row.nombreUsuario }}</td>
            <td class="text-center">{{ row.auditoriaFecha | date:'dd/MM/yyyy HH:mm' }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="text-center admgar-historial-vacio">
              {{ 'ADMGAR.MSG_SIN_HISTORIAL' | translate }}
            </td>
          </tr>
        </ng-template>

      </p-table>

    </p-tabPanel>

  </p-tabView>

  <ng-template pTemplate="footer">
    <div *ngIf="mostrarTabConfiguracion && tabEditarActiva === 0" class="admgar-modal-footer">
      <button type="button" pButton
              label="{{ 'BTN_CANCELAR' | translate }}"
              class="btn-primary-outline"
              (click)="cancelar()">
      </button>
      <button type="button" pButton
              icon="fa fa-check-circle"
              label="{{ 'BTN_GUARDAR' | translate }}"
              class="btn-primary-full"
              [disabled]="guardando"
              (click)="guardar()">
      </button>
    </div>
  </ng-template>

</p-dialog>

<ng-template #camposFormTpl>
  <form [formGroup]="formulario" novalidate class="admgar-formulario">

    <div class="grid admgar-form-fila">

      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>*{{ 'ADMGAR.LBL_CODIGO_SUPERF' | translate }}</label>
          <input pInputText
                 formControlName="codigoSuperf"
                 placeholder="{{ 'ADMGAR.PLACEHOLDER_INGRESAR' | translate }}"
                 maxlength="6">
          <small class="admgar-error" *ngIf="submitted && f.codigoSuperf.errors?.required">
            {{ 'ADMGAR.MSG_CAMPO_REQUERIDO' | translate }}
          </small>
          <small class="admgar-error" *ngIf="submitted && f.codigoSuperf.errors?.maxlength">
            {{ 'ADMGAR.MSG_MAX_6' | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>*{{ 'ADMGAR.LBL_CODIGO_SHIVAM' | translate }}</label>
          <input pInputText
                 type="text"
                 inputmode="numeric"
                 formControlName="codigoShivam"
                 placeholder="{{ 'ADMGAR.PLACEHOLDER_INGRESAR' | translate }}"
                 maxlength="3"
                 (keypress)="soloNumericos($event)">
          <small class="admgar-error" *ngIf="submitted && f.codigoShivam.errors?.required">
            {{ 'ADMGAR.MSG_CAMPO_REQUERIDO' | translate }}
          </small>
          <small class="admgar-error" *ngIf="submitted && f.codigoShivam.errors?.pattern">
            {{ 'ADMGAR.MSG_RANGO_SHIVAM' | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label class="admgar-campo-label--invisible">&#8203;</label>
          <div class="admgar-switch-row">
            <p-inputSwitch formControlName="indicadorHabilitado"></p-inputSwitch>
            <span class="admgar-switch-texto">{{ 'ADMGAR.LBL_HABILITADO' | translate }}</span>
          </div>
        </div>
      </div>

    </div>

    <div class="grid admgar-form-fila">

      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>*{{ 'ADMGAR.LBL_TIPO_GARANTIA' | translate }}</label>
          <p-dropdown formControlName="idTipoGarantia"
                      [options]="lisTiposGarantiaForm"
                      placeholder="{{ 'ADMGAR.PLACEHOLDER_SELECCIONAR' | translate }}"
                      optionLabel="label"
                      optionValue="value"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                      [style]="{width:'100%'}" *ngIf="!garantiaEditando">
          </p-dropdown>
          <label class="falso-combo-texto" *ngIf="garantiaEditando">{{ garantiaEditando.tipoGarantia }}</label>
          <small class="admgar-error" *ngIf="submitted && f.idTipoGarantia.errors?.required">
            {{ 'ADMGAR.MSG_CAMPO_REQUERIDO' | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>*{{ 'ADMGAR.LBL_CLASE_GARANTIA' | translate }}</label>
          <p-dropdown formControlName="idOtraGarantia"
                      [options]="lisClasesGarantiaForm"
                      placeholder="{{ 'ADMGAR.PLACEHOLDER_SELECCIONAR' | translate }}"
                      optionLabel="label"
                      optionValue="value"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                      [style]="{width:'100%'}" *ngIf="!garantiaEditando">
          </p-dropdown>
          <label class="falso-combo-texto" *ngIf="garantiaEditando">{{ garantiaEditando.otraGarantia }}</label>
          <small class="admgar-error" *ngIf="submitted && f.idOtraGarantia.errors?.required">
            {{ 'ADMGAR.MSG_CAMPO_REQUERIDO' | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>*{{ 'ADMGAR.LBL_BIEN_DERECHO' | translate }}</label>
          <p-dropdown formControlName="idBienDeDerecho"
                      [options]="lisBienesDerechos"
                      placeholder="{{ 'ADMGAR.PLACEHOLDER_SELECCIONAR' | translate }}"
                      optionLabel="label"
                      optionValue="value"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                      [filter]="true"
                      filterPlaceholder="{{ 'LBL_BUSCAR' | translate }}"
                      [style]="{width:'100%'}" *ngIf="!garantiaEditando">
          </p-dropdown>
          <label class="falso-combo-texto" *ngIf="garantiaEditando">{{ garantiaEditando.bienDeDerecho }}</label>
          <small class="admgar-error" *ngIf="submitted && f.idBienDeDerecho.errors?.required">
            {{ 'ADMGAR.MSG_CAMPO_REQUERIDO' | translate }}
          </small>
        </div>
      </div>

    </div>

    <div class="col-12" *ngIf="errorDuplicado">
      <small class="admgar-error" style="display:block; margin-bottom: 8px;">
        <i class="fa fa-exclamation-circle"></i>
        {{ 'ADMGAR.MSG_GARANTIA_DUPLICADA' | translate }}
      </small>
    </div>

    <div class="grid admgar-form-fila">

      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>*{{ 'ADMGAR.LBL_PAGARE_PN' | translate }}</label>
          <input pInputText
                 formControlName="pagarePersonaNatural"
                 placeholder="{{ 'ADMGAR.PLACEHOLDER_INGRESAR' | translate }}"
                 maxlength="6">
          <small class="admgar-error" *ngIf="submitted && f.pagarePersonaNatural.errors?.required">
            {{ 'ADMGAR.MSG_CAMPO_REQUERIDO' | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>{{ 'ADMGAR.LBL_PAGARE_PJ' | translate }}</label>
          <input pInputText
                 formControlName="pagarePersonaJuridica"
                 placeholder="{{ 'ADMGAR.PLACEHOLDER_INGRESAR' | translate }}"
                 maxlength="6">
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>{{ 'ADMGAR.LBL_SEGURO_VOLUNTARIO' | translate }}</label>
          <p-dropdown formControlName="idSeguro"
                      [options]="lisSeguros"
                      placeholder="{{ 'ADMGAR.PLACEHOLDER_SELECCIONAR' | translate }}"
                      optionLabel="label"
                      optionValue="value"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                      [showClear]="true"
                      [style]="{width:'100%'}">
          </p-dropdown>
        </div>
      </div>

    </div>

    <div class="admgar-modalidades-box" *ngIf="hayModalidades">

      <p class="admgar-modalidades-titulo">{{ 'ADMGAR.TIT_MODALIDADES' | translate }}</p>

      <div class="grid admgar-form-fila">

        <div class="col-6 md:col-3" *ngFor="let m of lisModalidades">
          <div class="admgar-campo-radio">
            <label class="admgar-radio-label">{{ m.nombre }}</label>
            <div class="admgar-radio-group">
              <p-radioButton [name]="getCampoModalidad(m.codigo)"
                             [value]="true"
                             [formControlName]="getCampoModalidad(m.codigo)"
                             [label]="'LBL_SI' | translate"
                             [inputId]="getCampoModalidad(m.codigo) + 'Si'">
              </p-radioButton>
              <p-radioButton [name]="getCampoModalidad(m.codigo)"
                             [value]="false"
                             [formControlName]="getCampoModalidad(m.codigo)"
                             [label]="'LBL_NO' | translate"
                             [inputId]="getCampoModalidad(m.codigo) + 'No'">
              </p-radioButton>
            </div>
            <small class="admgar-error"
                   *ngIf="submitted && f[getCampoModalidad(m.codigo)]?.errors?.required">
              {{ 'ADMGAR.MSG_SELECCIONE_OPCION' | translate }}
            </small>
          </div>
        </div>

      </div>

    </div>

    <div class="grid admgar-form-fila admgar-fila-requisitos">

      <div class="col-6 md:col-3">
        <div class="admgar-campo-radio">
          <label class="admgar-radio-label">{{ 'ADMGAR.LBL_REQ_CONSTITUCION' | translate }}</label>
          <div class="admgar-radio-group">
            <p-radioButton name="indicadorRequiereConstitucion"
                           [value]="true"
                           formControlName="indicadorRequiereConstitucion"
                           [label]="'LBL_SI' | translate"
                           inputId="rcSi">
            </p-radioButton>
            <p-radioButton name="indicadorRequiereConstitucion"
                           [value]="false"
                           formControlName="indicadorRequiereConstitucion"
                           [label]="'LBL_NO' | translate"
                           inputId="rcNo">
            </p-radioButton>
          </div>
          <small class="admgar-error" *ngIf="submitted && f.indicadorRequiereConstitucion.errors?.required">
            {{ 'ADMGAR.MSG_SELECCIONE_OPCION' | translate }}
          </small>
        </div>
      </div>

      <div class="col-6 md:col-3">
        <div class="admgar-campo-radio">
          <label class="admgar-radio-label">{{ 'ADMGAR.LBL_REQ_RESERVA' | translate }}</label>
          <div class="admgar-radio-group">
            <p-radioButton name="indicadorRequiereReserva"
                           [value]="true"
                           formControlName="indicadorRequiereReserva"
                           [label]="'LBL_SI' | translate"
                           inputId="rrSi">
            </p-radioButton>
            <p-radioButton name="indicadorRequiereReserva"
                           [value]="false"
                           formControlName="indicadorRequiereReserva"
                           [label]="'LBL_NO' | translate"
                           inputId="rrNo">
            </p-radioButton>
          </div>
          <small class="admgar-error" *ngIf="submitted && f.indicadorRequiereReserva.errors?.required">
            {{ 'ADMGAR.MSG_SELECCIONE_OPCION' | translate }}
          </small>
        </div>
      </div>

    </div>

  </form>
</ng-template>
